import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react"
import { Button } from "src/components/ui/button"
import { verifyCustomerEmail } from "src/features/bookings/api/bookingsApi"

// Public page the customer lands on from the verification email link.
export default function VerifyCustomerEmailPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [state, setState] = useState("verifying") // verifying | success | error
  const [name, setName] = useState("")

  useEffect(() => {
    let active = true
    verifyCustomerEmail(token)
      .then((d) => { if (active) { setName(d.customer_name || ""); setState("success") } })
      .catch(() => { if (active) setState("error") })
    return () => { active = false }
  }, [token])

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        {state === "verifying" && (
          <>
            <Loader2 className="mx-auto h-10 w-10 animate-spin text-slate-400" />
            <h1 className="mt-4 text-lg font-semibold text-slate-900">Verifying your email…</h1>
          </>
        )}
        {state === "success" && (
          <>
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
              <ShieldCheck className="h-7 w-7 text-emerald-500" />
            </div>
            <h1 className="mt-4 text-lg font-semibold text-slate-900">Email verified</h1>
            <p className="mt-1 text-sm text-slate-500">
              {name ? `Thanks, ${name}. ` : ""}Your email is confirmed. Your builder can now grant you portal access.
            </p>
            <Button className="mt-6" onClick={() => navigate("/login")}>Go to login</Button>
          </>
        )}
        {state === "error" && (
          <>
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-50">
              <ShieldX className="h-7 w-7 text-red-500" />
            </div>
            <h1 className="mt-4 text-lg font-semibold text-slate-900">Link invalid or expired</h1>
            <p className="mt-1 text-sm text-slate-500">
              This verification link is no longer valid. Please ask your builder to resend it.
            </p>
          </>
        )}
      </div>
    </div>
  )
}
